
export const getCommonEditorOptions = () => (
    {
        fontFamily: "Consolas, 'Courier New', monospace",
        fontSize: 14,
        lineHeight: 22,
        minimap: {
            enabled: false,
        },
        scrollbar: {
            verticalScrollbarSize: 8,
            horizontalScrollbarSize: 8,
            useShadows: true,
            verticalSliderSize: 8,
            horizontalSliderSize: 8,
        },
        roundedSelection: false,
        scrollBeyondLastLine: false,
        wordWrap: "on",
        wrappingIndent: "indent",
        automaticLayout: true,
        dragAndDrop: false,
        contextmenu: false,
        renderIndentGuides: true,
        renderLineHighlight: "gutter",
        theme: "vs-dark",
        colorDecorators: true,
        highlightActiveIndentGuide: true,
        highlightSelectedWord: true,
        selectionHighlight: true,
        overviewRulerBorder: true,
        overviewRulerLanes: 2,
        overviewRulerBorderRadius: 4,
        overviewRulerColor: "#555",
        overviewRulerLaneSize: 8,
        overviewRulerPosition: 2,
        overviewRulerWidth: 16,
        overviewRulerMargin: "0 0 0 4px",
    }
)